import React from "react";
import "./History.css";
import "./ManualEntry.css";
import Modal from "react-responsive-modal";
import { Col } from "react-bootstrap";
import { FormControl } from "react-bootstrap";
import { translations } from "../containers/assets/translations";
import { ToastContainer, ToastStore } from "react-toasts";

export default class PrinterSelection extends React.Component {
  constructor(props) {
    super(props);
    this.handleSaveChanges = this.handleSaveChanges.bind(this);
  }

  handleSaveChanges() {
    const { selectedDevice } = this.props;
    if (selectedDevice) {
      localStorage.setItem("selectedPrinter", JSON.stringify(selectedDevice));
      ToastStore.success("Changes saved successfully.");
    } else {
      ToastStore.error("Please select a printer before saving.");
    }
  }
  render() {
    const isMobile = window.innerWidth <= 768;
    
    const isPrinterAvailable = this.props.devices.length > 0;

    return (
      <div>
        <ToastContainer
          store={ToastStore}
          className="toaster"
          lightBackground
          position={ToastContainer.POSITION.TOP_CENTER}
        />
        <Modal
          open={this.props.OpenPrinters}
          onClose={this.props.onClickPrintSelection}
          center
        >
            <Col className="HeaderTicks">Change printer</Col>
            <div className="mod">
                <div className="row">
                    <div className="col-md-12">
                        <FormControl
                            componentClass="select"
                            className="form-control"
                            defaultValue={this.props.selectedDevice}
                            open={this.props.OpenPrinters}
                            onChange={this.props.changeSelectedDevice}
                            onClick={(e) => {
                                e.target.open = true;
                            }}
                            style={{
                                display: !isPrinterAvailable ? "none" : "block",
                                width: isMobile ? "100%" : "440px",
                            }}
                        >
                          <option value="" disabled>
                            {translations[this.props.lang]["Select a printer"]}{"\t\t\t\t"}
                          </option>
                          {this.props.devices.map(device => (
                            <option key={device.uid} value={device.uid}>{device.name}</option>
                          ))}
                        </FormControl>
                    </div>
                </div>
                <div 
                  className="row mt-3" 
                  style={{
                      display: !isPrinterAvailable ? "none" : "block",
                  }}
                >
                    <div className="col-md-6">
                        <button 
                          type="button" 
                          onClick={this.handleSaveChanges}
                          className="btn btn-primary btn-block"
                          style={{
                            display: !isPrinterAvailable ? "none" : "block",
                          }}
                        >
                          {translations[this.props.lang]["Save Changes"]}{"\t\t\t\t"}
                        </button>
                    </div>

                    {this.props.canTestPrint  &&
                    <div 
                      className="col-md-6" 
                      >
                        <button 
                          type="button" 
                          className="btn btn-primary btn-block"
                          onClick={() => this.props.writeToSelectedPrinter(`
N
O,D
Q1600,10
R200,0
I8,D
S6
D10
UA
ZT
B150,120,1,1,2,2,90,B,"TEST"
A590,0120,1,3,1,1,N,"Nom/Name"
A560,0090,1,4,1,1,N,"TEST"
A530,0090,1,4,1,1,N,"TEST"
A490,0080,1,3,1,1,N,"Depart/Departure"
A460,0060,1,4,1,1,N,"21/02/2024 15:00"
A420,0090,1,3,1,1,N,"Company"
A390,0100,1,4,1,1,N,"TEST"
A350,0100,1,3,1,1,N,"Ticket No"
A320,0100,1,4,1,1,N,"TEST"
A280,0100,1,3,1,1,N,"Reservation No"
A250,0100,1,4,1,1,N,"TEST"
A210,0100,1,3,1,1,N,"Category"
A180,0100,1,4,1,1,N,"ADULT"
B150,500,1,1,2,2,90,B,"TEST"
A590,0520,1,3,1,1,N,"Nom/Name"
A560,0490,1,4,1,1,N,"TEST"
A530,0490,1,4,1,1,N,"TEST"
A490,0480,1,3,1,1,N,"Depart/Departure"
A460,0460,1,4,1,1,N,"21/02/2024 15:00"
A420,0490,1,3,1,1,N,"Company"
A390,0500,1,4,1,1,N,"TEST"
A350,0500,1,3,1,1,N,"Ticket No"
A320,0500,1,4,1,1,N,"TEST"
A280,0500,1,3,1,1,N,"Reservation No"
A250,0500,1,4,1,1,N,"TEST"
A210,0500,1,3,1,1,N,"Category"
A180,0500,1,4,1,1,N,"ADULT"
A580,0920,1,2,1,1,N,"Date Depart/Departure Date"
A580,1350,1,2,1,1,N,"Navire/Vessel"
A550,0920,1,4,1,1,N,"21/02/2024 15:00"
A550,1350,1,4,1,1,N,"TEST"
A490,0920,1,4,1,1,N,"TANGER MED - ALGECIRAS"
A490,1350,1,4,1,1,N,"TEST"
A380,1350,1,2,1,1,N,"Passport"
A360,1350,1,4,1,1,N,"TEST"
A330,1350,1,2,1,1,N,"Category"
A310,1350,1,4,1,1,N,"TEST"
A450,0920,1,3,1,1,N,"Nom/Name"
A450,1130,1,4,1,1,N,"TEST"
A420,1130,1,4,1,1,N,"TEST"
A390,0920,1,3,1,1,N,"Sex"
A390,1130,1,4,1,1,N,"M"
A350,0920,1,3,1,1,N,"Date of Birth"
A350,1130,1,4,1,1,N,"TEST"
A310,0920,1,3,1,1,N,"Reservation No"
A310,1130,1,4,1,1,N,"TEST"
A270,0920,1,3,1,1,N,"Accommodation"
A270,1130,1,4,1,1,N," "
A230,0920,1,3,1,1,N,"Ticket No"
A230,1130,1,4,1,1,N,"TEST"
A150,1300,1,3,1,1,N,"Print Date"
A120,1300,1,4,1,1,N,"TEST"
A270,1300,1,3,1,1,N,"Parking"
A270,1470,1,4,1,1,N,"1"
B150,1000,1,1,2,2,90,B,"TEST"
P1
`)}
                        > 
                          {translations[this.props.lang]["Print Test"]}{"\t\t\t\t"}
                        </button>
                    </div>
                    }
                </div>
                {!isPrinterAvailable && (
                  <div className="row">
                    <div className="col-md-12">
                      <p>No printers available. If you haven't installed the Zebra Browser Print plugin <br/> <a href="/zebra-browser-print-windows-v132489.exe" target="_blank" style={{color: "#0d6efd"}}>Click here to download the Zebra Browser Print</a></p>
                      <p>Additionally check the plugin settings, if you have configured everything correctly.</p>
                    </div>
                  </div>
                )}
            </div>
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PrinterSelection.js